var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 506.5 156.5",
    style: {
      enableBackground: "new 0 0 506.5 156.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C23438;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,59.1v30.8c0,2.5,0.4,4.3,1.3,5.3c0.9,1,2.8,1.4,6,1.4v5.3H70v-5.3h1.2c3,0,4.9-0.5,5.7-1.5 c0.8-1,1.2-2.7,1.2-5.2v-15c0-2.5-0.4-4.2-1.2-5.2c-0.8-1-2.7-1.5-5.7-1.5H70v-5.3L95.4,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,42.2c0-2.6,1-4.8,2.9-6.6c1.9-1.9,4.3-2.8,7-2.8c2.7,0,5.1,0.9,7,2.8c1.9,1.8,2.9,4,2.9,6.7 c0,2.6-1,4.8-2.9,6.7c-1.9,1.8-4.3,2.8-7,2.8c-2.8,0-5.2-0.9-7.1-2.8C76.4,46.9,75.4,44.7,75.4,42.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.1,50.8c0-2.2,0.8-4.2,2.5-5.8c1.7-1.6,3.7-2.4,6.1-2.4c2.4,0,4.4,0.8,6.1,2.4c1.7,1.6,2.5,3.5,2.5,5.8 c0,2.3-0.8,4.2-2.5,5.8c-1.7,1.6-3.7,2.4-6.1,2.4c-2.5,0-4.5-0.8-6.2-2.5C51.9,54.9,51.1,53,51.1,50.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,50.9c0-2.5,0.9-4.6,2.8-6.4c1.9-1.8,4.1-2.7,6.8-2.7c2.7,0,4.9,0.9,6.8,2.7c1.8,1.8,2.8,3.9,2.8,6.4 c0,2.5-0.9,4.7-2.8,6.4c-1.9,1.8-4.1,2.7-6.7,2.7c-2.7,0-5-0.9-6.8-2.7C103.5,55.5,102.6,53.4,102.6,50.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,70c0,3.9-3.3,7-7.4,7c-4.1,0-7.4-3.1-7.4-7c0-3.9,3.3-7,7.4-7C50.2,63,53.5,66.1,53.5,70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.7,90.5c0,3.3-2.8,6-6.3,6c-3.5,0-6.3-2.7-6.3-6c0-3.3,2.8-6,6.3-6C48.9,84.5,51.7,87.2,51.7,90.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.2,107c0,2.8-2.4,5.1-5.4,5.1c-3,0-5.4-2.3-5.4-5.1c0-2.8,2.4-5.1,5.4-5.1 C57.8,101.9,60.2,104.2,60.2,107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2,117.2c0,2.4-2,4.3-4.6,4.3c-2.5,0-4.6-1.9-4.6-4.3c0-2.4,2-4.3,4.6-4.3 C72.2,112.9,74.2,114.8,74.2,117.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6,120.4c0,2-1.7,3.7-3.9,3.7c-2.1,0-3.9-1.6-3.9-3.7c0-2,1.7-3.7,3.9-3.7 C87.8,116.8,89.6,118.4,89.6,120.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9,117.9c0,1.7-1.5,3.1-3.3,3.1c-1.8,0-3.3-1.4-3.3-3.1c0-1.7,1.5-3.1,3.3-3.1 C102.4,114.8,103.9,116.2,103.9,117.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.8,111.9c0,1.5-1.3,2.6-2.8,2.6c-1.5,0-2.8-1.2-2.8-2.6c0-1.5,1.3-2.6,2.8-2.6 C113.5,109.2,114.8,110.4,114.8,111.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.6,103.7c0,1.2-1.1,2.3-2.4,2.3c-1.3,0-2.4-1-2.4-2.3c0-1.2,1.1-2.3,2.4-2.3 C121.6,101.4,122.6,102.4,122.6,103.7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "342.7,102.4 332.7,102.4 332.7,62.3 342.7,62.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "386.3,102.3 378.1,102.3 360.8,80 360.8,102.4 351,102.4 351,62.2 359,62.2 376.7,84.4 376.7,62.2 386.3,62.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "419.6,88.4 404.3,88.4 404.3,102.3 394.7,102.3 394.7,62.2 420.9,62.2 420.9,70.8 404.3,70.9 404.3,79.4 419.6,79.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.3,82c0,3.8-0.8,7.2-2.4,10.4c-1.6,3.1-3.9,5.6-7.1,7.5c-3.1,1.9-6.9,2.8-11.4,2.8 c-4.5,0-8.4-1-11.6-2.9c-3.2-1.9-5.5-4.5-7-7.6c-1.5-3.1-2.3-6.5-2.3-10.1c0-3.6,0.8-7,2.3-10.1c1.5-3.2,3.9-5.7,7-7.6 c3.2-1.9,7-2.9,11.6-2.9c3.4,0,6.4,0.5,9.1,1.6c2.7,1.1,4.9,2.6,6.6,4.5c1.7,1.9,3,4.1,3.9,6.6C466.8,76.6,467.2,79.3,467.3,82  M456.6,82c0-1.6-0.2-3.1-0.7-4.4c-0.4-1.3-1.1-2.5-2-3.5c-0.9-1-2-1.7-3.2-2.3c-1.3-0.5-2.7-0.8-4.4-0.8c-3.2,0-5.7,1-7.5,3.1 c-1.8,2-2.7,4.7-2.7,8c0,3.3,0.9,5.9,2.8,8c1.8,2,4.3,3,7.5,3c2.2,0,4-0.5,5.6-1.4c1.5-0.9,2.7-2.2,3.5-3.9 C456.2,86.1,456.6,84.2,456.6,82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.5,67.9c-4.8-2.6-7-3.2-11.7-3.2c-4.9,0-9,1.7-12.3,5.2c-3.3,3.4-5.2,7.6-5.2,12.8c0,5.2,2,9.5,5.3,12.8 c3.3,3.3,7.6,5,12.8,5c4.3,0,7.3-0.6,11.8-3.4l1.6,2.3c-4.6,2.9-8.8,4-13.4,4c-6,0-11.1-1.9-15.1-5.9c-4-3.9-6.1-8.9-6.1-14.7 c0-5.9,2-10.9,6.1-14.9c4.1-4,9-6,14.7-6c4.5,0,9.3,1.4,13,3.9L172.5,67.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "237.5,62.3 237.5,64.9 218.6,64.9 218.6,81.1 236.5,81.1 236.5,83.7 218.6,83.7 218.6,100.1 238.1,100.1 238.1,102.7 215.5,102.7 215.5,62.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.8,62.2l11.2,0c7.2,0,11.4,1.9,15.2,5.6c3.8,3.8,5.7,8.6,5.7,14.6c0,5.9-1.9,10.7-5.6,14.5 c-3.7,3.8-7.8,5.7-14.7,5.7l-11.8,0V62.2z M249,64.8V100l8.9,0c5.2,0,8.4-1.6,11.9-4.9c3.5-3.2,5.2-7.5,5.2-12.8 c0-5.2-1.7-9.4-5.2-12.7c-3.4-3.3-6.7-4.9-12.2-4.9L249,64.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "288.7,102.6 285.6,102.6 285.6,62.1 288.7,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "326.2,62.1 326.2,64.7 312.2,64.7 312.2,102.5 309.1,102.5 309.1,64.7 295.1,64.7 295.1,62.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.8,81.1V64.9h6.6c3.4,0,6.5,0.7,8.3,2.1c1.8,1.4,2.8,3.3,2.8,5.8c0,2.5-1.1,4.5-2.8,5.9 c-1.8,1.4-4.8,2.4-8.3,2.4L185.8,81.1z M209.5,102.8l-11.2-20c0.1,0,0.3-0.1,0.4-0.1c5.4-2.1,7.7-5.2,7.7-9.9 c0-3.2-1.2-5.8-3.5-7.6c-2.3-1.9-5.6-2.8-10-2.8h-10.4v40.5l3.2,0V83.7l4.4,0c1.7,0,3.7-0.1,5.5-0.4l10.7,19.5H209.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a5923dafc7ae5b055d5194091e4a5874.svg";
export { ForwardRef as ReactComponent };